import { render, staticRenderFns } from "./StatesLoader.vue?vue&type=template&id=022da19e&scoped=true&v-once=true&"
var script = {}
import style0 from "./StatesLoader.vue?vue&type=style&index=0&id=022da19e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022da19e",
  null
  
)

export default component.exports